import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const PrefetchIndicator = ({ isPrefetching, progress }) => {
  return (
    <AnimatePresence>
      {isPrefetching && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="fixed top-4 right-4 bg-white rounded-lg shadow-lg p-4 z-50"
        >
          <div className="flex items-center space-x-3">
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-gray-300 border-t-blue-600"></div>
            <div>
              <p className="text-sm font-medium text-gray-700">Loading spreadsheets...</p>
              <div className="mt-1 w-48 bg-gray-200 rounded-full h-2">
                <motion.div
                  className="bg-blue-600 h-2 rounded-full"
                  initial={{ width: 0 }}
                  animate={{ width: `${progress}%` }}
                  transition={{ duration: 0.3 }}
                />
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PrefetchIndicator;